export const handleRadioChange = (rowIndex, columnIndex, selected, setSelected, rowTitles, columnTitles, selectedColumnIndex, setSelectedColumnIndex) => {
    const newSelected = [...selected];
    newSelected[rowIndex] = columnIndex;
    setSelected(newSelected);

    const newSelectedColumnIndex = [...selectedColumnIndex];
    newSelectedColumnIndex[rowIndex] = { row: rowTitles[rowIndex], column: columnTitles[columnIndex] };
    setSelectedColumnIndex(newSelectedColumnIndex);
};

export const handleRowTitleChange = (index, event, rowTitles, setRowTitles, selectedColumnIndex, setSelectedColumnIndex) => {
    const newTitles = [...rowTitles];
    newTitles[index] = event.target.value;
    setRowTitles(newTitles);

    const newSelectedColumnIndex = selectedColumnIndex.map((selection, rowIndex) => {
        if (rowIndex === index) {
            return { ...selection, row: event.target.value };
        }
        return selection;
    });
    setSelectedColumnIndex(newSelectedColumnIndex);
};

export const handleColumnTitleChange = (index, event, columnTitles, setColumnTitles, selectedColumnIndex, setSelectedColumnIndex) => {
    const newTitles = [...columnTitles];
    newTitles[index] = event.target.value;
    setColumnTitles(newTitles);

    const newSelectedColumnIndex = selectedColumnIndex.map(selection => {
        if (selection.column === columnTitles[index]) {
            return { ...selection, column: event.target.value };
        }
        return selection;
    });
    setSelectedColumnIndex(newSelectedColumnIndex);
};

export const handleRowDelete = (index, rowTitles, setRowTitles, selectedColumnIndex, setSelectedColumnIndex, selected, setSelected) => {
    const newRows = [...rowTitles];
    newRows.splice(index, 1);
    setRowTitles(newRows);

    const newSelectedColumnIndex = selectedColumnIndex.filter((_, i) => i !== index);
    setSelectedColumnIndex(newSelectedColumnIndex);

    const newSelected = selected.filter((_, i) => i !== index);
    setSelected(newSelected);
};

export const handleColumnDelete = (index, columnTitles, setColumnTitles, selectedColumnIndex, setSelectedColumnIndex) => {
    const newColumns = [...columnTitles];
    newColumns.splice(index, 1);
    setColumnTitles(newColumns);

    const newSelectedColumnIndex = selectedColumnIndex.map(selection => {
        if (selection.column === columnTitles[index]) {
            return { row: selection.row, column: null };
        }
        return selection;
    });
    setSelectedColumnIndex(newSelectedColumnIndex);
};

export const handleAddRow = (rowTitles, setRowTitles, selectedColumnIndex, setSelectedColumnIndex, selected, setSelected) => {
    setRowTitles(prevTitles => [...prevTitles, `سطر ${prevTitles.length + 1}`]);
    setSelectedColumnIndex(prev => [...prev, { row: null, column: null }]);
    setSelected(prev => [...prev, null]);
};

export const addColumn = (columnTitles, setColumnTitles) => {
    const newColumnTitles = [...columnTitles, `ستون ${columnTitles.length + 1}`];
    setColumnTitles(newColumnTitles);
};

export const handleHeadingFocus = (setHeadingFocused, event) => {
    setHeadingFocused(true);
    event.target.select();
};

export const handleClickOutside = (containerRef, setSubHeaderVisible, setHeadingFocused, setShow) => (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
        setSubHeaderVisible(false);
        setHeadingFocused(false);
        setShow(false);
    } else {
        setSubHeaderVisible(true);
        setHeadingFocused(true);
        setShow(true);
    }
};

export const handleCondition = (currentPage, readOnly, dataCondition, title, setCondition) => {
    if (currentPage === '/publish') {
        if (readOnly || dataCondition) {
            if (title === 'Table') {
                setCondition(true);
            } else {
                setCondition(false);
            }
        } else {
            setCondition(false);
        }
    } else {
        setCondition(false);
    }
};

export const fillInputValue = (drawerData, existingComponentIndex, tableValue, rowTitles, columnTitles, selectedColumnIndex, show, readOnly) => {
    if (drawerData.length > 0) {
        const component = drawerData[existingComponentIndex];
        component.state.tableValue = tableValue;
        component.state.rowTitles = rowTitles;
        component.state.columnTitles = columnTitles;
        component.state.mainSelectedColumnIndex = selectedColumnIndex;
        component.state.show = show;
        component.state.readOnly = readOnly;
    }
};
